export default __webpack_public_path__ + "static/media/Tracker.cbea23d9.gif";